import {UserModel} from './_models'

export type RoleProfile = Pick<UserModel, 'administrator' | 'manager' | 'external_user'>

export function canAccessAdminOrManagerFeatures(user?: RoleProfile | null): boolean {
  return !!(user?.administrator || user?.manager)
}

export function canAccessGeneralSettingsMenu(user?: RoleProfile | null): boolean {
  return canAccessAdminOrManagerFeatures(user)
}

export function canAccessConfigsPage(user?: RoleProfile | null): boolean {
  return canAccessAdminOrManagerFeatures(user)
}

export function canAccessBillingAndCompanyAccount(user?: RoleProfile | null): boolean {
  return !!user?.administrator
}

export function canManageProjectActions(user?: RoleProfile | null): boolean {
  return canAccessAdminOrManagerFeatures(user)
}

export function canAccessHolidaysPage(user?: RoleProfile | null): boolean {
  return canAccessAdminOrManagerFeatures(user)
}

export function canAccessStagesPage(user?: RoleProfile | null): boolean {
  return canAccessAdminOrManagerFeatures(user)
}

export function canAccessUsersPage(user?: RoleProfile | null): boolean {
  return canAccessAdminOrManagerFeatures(user)
}

export function canAccessSettingsGearAdminItems(user?: RoleProfile | null): boolean {
  return canAccessAdminOrManagerFeatures(user)
}
